import React, { useState, useEffect } from 'react';
import './Toast.css';

const Toast = ({ id, message, duration = 5000, onClose }) => {
  const [timeLeft, setTimeLeft] = useState(duration / 1000);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (duration <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          handleClose();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [duration]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose(id);
    }, 300); // Wait for fade out animation
  };

  const formatTime = (seconds) => {
    return Math.ceil(seconds);
  };

  return (
    <div className={`toast ${isVisible ? 'visible' : 'hidden'}`} role="alert">
      <div className="toast-content">
        <p className="toast-message">{message}</p>
      </div>
      <div className="toast-actions">
        <button className="toast-close-btn" onClick={handleClose} aria-label="Close toast">
          ×
        </button>
        {duration > 0 && (
          <div className="toast-countdown">
            <span className="countdown-text">{formatTime(timeLeft)}s</span>
            <div className="countdown-bar">
              <div 
                className="countdown-progress" 
                style={{ width: `${(timeLeft / (duration / 1000)) * 100}%` }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Toast;
